import type { AuthOptions } from '@gravitano/vue-auth'

export const authOptions: AuthOptions = {
  endpoints: {
    login: {
      url: '/sessions',
      method: 'post',
    },
    logout: {
      url: '/auth/logout',
      method: 'delete',
    },
    user: {
      url: '/auth/me',
      method: 'get',
    },
    refresh: {
      url: '/refresh_token',
      method: 'post',
    },
  },
  token: {
    property: 'data.access_token',
    type: '',
    storageName: 'auth.token',
    autoDecode: true,
    name: 'Authorization',
  },
  user: {
    autoFetch: false,
    property: 'data',
    storageName: 'auth.user',
  },
  refreshToken: {
    enabled: false,
    property: 'data.refresh_token',
    maxAge: 60 * 60 * 24 * 30, // default 30 days
    storageName: 'auth.refresh_token',
    name: 'refresh_token',
    autoLogout: true,
  },
  moduleName: 'auth',
  expiredStorage: 'auth.expired',
  redirect: {
    home: '/',
    login: '/auth/login',
  },
  registerAxiosInterceptors: false,
  storage: {
    driver: 'local',
  },
}
